import * as tslib_1 from "tslib";
import { from } from 'rxjs';
import { mergeAll } from 'rxjs/operators';
import { isQueryableMapCoreLayer } from '../../src/types';
import { LayerApi } from '../api/layer-api';
import { SpatialApi } from '../api/spatial-api';
import { environment } from '../environment';
import { ESRI } from '../esri-loader-util';
import { GisToolsService } from './gis-tools.service';
import { LayerService } from './layer.service';
import { ToSqlStringService } from './to-sql-string.service';
import * as i0 from "@angular/core";
import * as i1 from "../api/spatial-api";
import * as i2 from "../api/layer-api";
import * as i3 from "./layer.service";
import * as i4 from "./gis-tools.service";
import * as i5 from "./to-sql-string.service";
var SpatialQueryService = /** @class */ (function () {
    function SpatialQueryService(spatialApi, layerApi, layerService, gisToolsService, toSqlStringService) {
        this.spatialApi = spatialApi;
        this.layerApi = layerApi;
        this.layerService = layerService;
        this.gisToolsService = gisToolsService;
        this.toSqlStringService = toSqlStringService;
    }
    SpatialQueryService.prototype.getLayerGeometry = function (featureSet) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, Point_1, Multipoint, multipoints_1, _b, Polyline_1, singlePolyline_1, _c, Polygon_1, singlePolygon_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(featureSet.geometryType.toLowerCase() === 'point')) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all([ESRI.Point, ESRI.Multipoint])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_d.sent(), 2]), Point_1 = _a[0], Multipoint = _a[1];
                        multipoints_1 = new Multipoint({
                            spatialReference: featureSet.features[0].geometry.spatialReference
                        });
                        featureSet.features.forEach(function (graphic) {
                            var point = new Point_1(graphic.geometry);
                            multipoints_1.addPoint(point);
                        });
                        return [2 /*return*/, multipoints_1];
                    case 2:
                        if (!(featureSet.geometryType.toLowerCase() === 'polyline' || featureSet.geometryType.toLowerCase() === 'line')) return [3 /*break*/, 4];
                        return [4 /*yield*/, Promise.all([ESRI.Polyline])];
                    case 3:
                        _b = tslib_1.__read.apply(void 0, [_d.sent(), 1]), Polyline_1 = _b[0];
                        singlePolyline_1 = new Polyline_1({
                            spatialReference: featureSet.features[0].geometry.spatialReference
                        });
                        featureSet.features.forEach(function (graphic) {
                            var line = new Polyline_1(graphic.geometry);
                            if (line.paths.length > 0) {
                                singlePolyline_1.paths = singlePolyline_1.paths.concat(line.paths);
                            }
                        });
                        return [2 /*return*/, singlePolyline_1];
                    case 4:
                        if (!(featureSet.geometryType.toLowerCase() === 'polygon')) return [3 /*break*/, 6];
                        return [4 /*yield*/, Promise.all([ESRI.Polygon])];
                    case 5:
                        _c = tslib_1.__read.apply(void 0, [_d.sent(), 1]), Polygon_1 = _c[0];
                        singlePolygon_1 = new Polygon_1({
                            spatialReference: featureSet.features[0].geometry.spatialReference
                        });
                        featureSet.features.forEach(function (graphic) {
                            var polygon = new Polygon_1(graphic.geometry);
                            if (polygon.rings.length > 0) {
                                singlePolygon_1.rings = singlePolygon_1.rings.concat(polygon.rings);
                            }
                        });
                        return [2 /*return*/, singlePolygon_1];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    SpatialQueryService.prototype.filterWithGeometry = function (url, oidField, geometry) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, Query, QueryTask, queryTask, query, queryResult;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([ESRI.Query, ESRI.QueryTask])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), Query = _a[0], QueryTask = _a[1];
                        queryTask = new QueryTask({
                            url: url
                        });
                        query = new Query({
                            outFields: [oidField],
                            geometry: geometry,
                            spatialRelationship: 'intersects',
                            returnGeometry: false
                        });
                        return [4 /*yield*/, queryTask.execute(query)];
                    case 2:
                        queryResult = _b.sent();
                        return [2 /*return*/, queryResult];
                }
            });
        });
    };
    //Li is still working on the guid part so this is working as-is for now. Once the guid stuff is set up,
    //we will use that instead of returning the objectids here.
    SpatialQueryService.prototype.filterLayerWithGeometry = function (sublayer, geometry) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, features, outField;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = sublayer.createQuery();
                        query.outFields = [sublayer.source.dataSource.oidFields];
                        query.geometry = geometry;
                        query.spatialRelationship = 'intersects';
                        query.returnGeometry = false;
                        return [4 /*yield*/, sublayer.queryFeatures(query)];
                    case 1:
                        features = _a.sent();
                        outField = query.outFields[0].toUpperCase();
                        return [2 /*return*/, this.getObjectIdList(features.features, outField)];
                }
            });
        });
    };
    SpatialQueryService.prototype.getObjectIdList = function (features, objectIdField) {
        var objectIds = [];
        features.forEach(function (feature) {
            objectIds.push(feature.attributes[objectIdField]);
        });
        return objectIds;
    };
    /** Gets a GUID query object given a guid string */
    SpatialQueryService.prototype.getGuidQuery = function (guid, name) {
        if (name === void 0) { name = null; }
        var query = {
            field: 'OBJECTID',
            operator: 'GUID',
            value: guid
        };
        if (name) {
            query.name = name;
        }
        return query;
    };
    /** Gets a query object given a objectId list */
    SpatialQueryService.prototype.getQueryByObjectIds = function (objectIds, name) {
        if (name === void 0) { name = null; }
        var query = {
            field: 'OBJECTID',
            operator: 'IN',
            isMultiple: true,
            multiValue: objectIds.map(String)
        };
        if (name) {
            query.name = name;
        }
        return query;
    };
    /** Gets a specific type of object for filtering dynamic layers spatially */
    SpatialQueryService.prototype.getIDynamicLayerSpatialFromLayer = function (layer) {
        var _this = this;
        var sublayers = [];
        var queries;
        layer.sublayers.forEach(function (sublayer) {
            if (layer.mapcoreProps) {
                queries = _this.toSqlStringService.getSimplifiedDeepCopyOfQuery(layer.mapcoreProps.query, false);
            }
            else {
                queries = _this.toSqlStringService.getSimplifiedDeepCopyOfQuery(sublayer.mapcoreProps.query, false);
            }
            var hasParentQuery = false;
            if (queries && queries.subqueries && queries.subqueries.length > 0 && layer.mapcoreProps.parentQuery && layer.mapcoreProps.parentQuery.field) {
                hasParentQuery = queries.subqueries.filter(function (x) { return x.field === layer.mapcoreProps.parentQuery.field && x.operator === layer.mapcoreProps.parentQuery.operator && x.value === layer.mapcoreProps.parentQuery.value; }).length > 0;
            }
            if (layer.mapcoreProps.parentQuery && !hasParentQuery) {
                queries = _this.toSqlStringService.addFilter(queries, layer.mapcoreProps.parentQuery);
            }
            sublayers.push({
                id: sublayer.id,
                source: sublayer.source,
                query: queries
            });
        });
        return {
            id: layer.id,
            sublayers: sublayers
        };
    };
    /**
     * Add or update spatial query result to layer
     */
    SpatialQueryService.prototype.handleResults = function (results, spParams, isNewLayer, isIntersect, title, suffixOverride, renewLayerId) {
        if (title === void 0) { title = ''; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                results.forEach(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var layer, query, spatialQueryParams, newTitle, esriLayer, newQuery, parentQuery, layerType, layerSettings, esriLayers, mapcoreProps, newLayer;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                layer = this.layerService.getEsriLayerByUniqueId(renewLayerId ? renewLayerId : result.id);
                                spatialQueryParams = tslib_1.__assign({}, spParams);
                                spatialQueryParams.primaryDynamicLayers = tslib_1.__spread(spParams.primaryDynamicLayers);
                                spatialQueryParams.primaryFeatureLayers = tslib_1.__spread(spParams.primaryFeatureLayers);
                                if (result.guid) {
                                    spatialQueryParams.guid = result.guid;
                                }
                                else {
                                    spatialQueryParams.objectIds = result.objectIds;
                                }
                                if (!renewLayerId) {
                                    this.filterSelectedLayers(this.GetMapLayerList([layer]), spatialQueryParams.primaryDynamicLayers, spatialQueryParams.primaryFeatureLayers);
                                }
                                if (!isNewLayer) return [3 /*break*/, 5];
                                newTitle = title;
                                if (title === '') {
                                    newTitle = layer.mapcoreProps.name;
                                    newTitle += suffixOverride ? " - " + suffixOverride : isIntersect ? ' - Intersect' : ' - Difference';
                                }
                                esriLayer = void 0;
                                newQuery = this.toSqlStringService.getSimplifiedDeepCopyOfQuery(layer.mapcoreProps.query);
                                parentQuery = void 0;
                                if (layer.mapcoreProps.spatialQueryParams) {
                                    if (result.guid) {
                                        newQuery = this.updateQueryWithGUID(newQuery, result.guid, layer.mapcoreProps.spatialQueryParams.guid);
                                    }
                                    else {
                                        newQuery = this.updateQueryWithObjectIds(newQuery, result.objectIds, layer.mapcoreProps.spatialQueryParams.objectIds);
                                    }
                                }
                                else {
                                    if (result.guid) {
                                        newQuery = this.updateQueryWithGUID(newQuery, result.guid);
                                    }
                                    else if (result.objectIds) {
                                        newQuery = this.updateQueryWithObjectIds(newQuery, result.objectIds);
                                    }
                                }
                                if (layer.mapcoreProps.parentQuery) {
                                    parentQuery = tslib_1.__assign({}, layer.mapcoreProps.parentQuery);
                                }
                                layerType = this.layerService.getLayerType(layer);
                                if (!(layerType === 'dynamic')) return [3 /*break*/, 2];
                                layerSettings = { id: layer.mapcoreProps.parentId, name: newTitle, query: newQuery, spatialQueryParams: spatialQueryParams, parentQuery: parentQuery };
                                return [4 /*yield*/, this.layerService.addMapcoreLayersToMap([layerSettings])];
                            case 1:
                                esriLayers = _a.sent();
                                esriLayer = esriLayers[0];
                                spatialQueryParams.primaryDynamicLayers[0].id = esriLayer.id;
                                return [3 /*break*/, 4];
                            case 2:
                                if (!(layerType === 'feature')) return [3 /*break*/, 4];
                                mapcoreProps = tslib_1.__assign({}, layer.mapcoreProps);
                                mapcoreProps.name = newTitle;
                                mapcoreProps.query = newQuery;
                                mapcoreProps.spatialQueryParams = spatialQueryParams;
                                return [4 /*yield*/, this.layerService.addExternalLayersToMap(tslib_1.__assign({}, mapcoreProps))];
                            case 3:
                                esriLayer = _a.sent();
                                spatialQueryParams.primaryFeatureLayers[0].id = esriLayer.id;
                                _a.label = 4;
                            case 4:
                                newLayer = this.layerService.getEsriLayerByUniqueId(esriLayer.id);
                                newLayer.mapcoreProps.spatialQueryParams = spatialQueryParams;
                                if (isQueryableMapCoreLayer(newLayer)) {
                                    newLayer.refresh();
                                }
                                return [3 /*break*/, 6];
                            case 5:
                                if (isQueryableMapCoreLayer(layer)) {
                                    if (layer.mapcoreProps.spatialQueryParams) {
                                        query = this.updateLayerWithGUID(layer, result.guid, layer.mapcoreProps.spatialQueryParams.guid);
                                    }
                                    else {
                                        query = this.updateLayerWithGUID(layer, result.guid);
                                    }
                                    this.layerService.updateLayerFilter(layer, query);
                                    layer.mapcoreProps.spatialQueryParams = spatialQueryParams;
                                    layer.refresh();
                                }
                                _a.label = 6;
                            case 6: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    /**
     * Service used to renew existing spatial queried layer
     * Add layerId as optional for now in case some other applications other than Onemap and Maintenance IQ uses it.
     */
    SpatialQueryService.prototype.renewQuery = function (queryParams, layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newLayer, id, isIntersect, primaryDynamicLayers, primaryFeatureLayers, joinedDynamicLayers, joinedFeatureLayers, joinedGeometries, processingType, srMatch, spatialQueryParams, dynamicResults, featureResults, results;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newLayer = false, id = layerId, isIntersect = queryParams.isIntersect, primaryDynamicLayers = queryParams.primaryDynamicLayers, primaryFeatureLayers = queryParams.primaryFeatureLayers, joinedDynamicLayers = queryParams.joinedDynamicLayers, joinedFeatureLayers = queryParams.joinedFeatureLayers, joinedGeometries = queryParams.joinedGeometries, processingType = queryParams.processingType, srMatch = queryParams.srMatch;
                        spatialQueryParams = {
                            primaryDynamicLayers: primaryDynamicLayers,
                            primaryFeatureLayers: primaryFeatureLayers,
                            joinedDynamicLayers: joinedDynamicLayers,
                            joinedFeatureLayers: joinedFeatureLayers,
                            joinedGeometries: joinedGeometries,
                            isIntersect: isIntersect,
                            guid: '',
                            processingType: processingType,
                            srMatch: srMatch
                        };
                        dynamicResults = [];
                        featureResults = [];
                        if (!(primaryDynamicLayers && primaryDynamicLayers.length && primaryDynamicLayers.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.spatialQuery(isIntersect, primaryDynamicLayers, [], joinedDynamicLayers, joinedFeatureLayers, joinedGeometries, processingType, srMatch)];
                    case 1:
                        dynamicResults = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(primaryFeatureLayers && primaryFeatureLayers.length && primaryFeatureLayers.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.spatialQuery(isIntersect, [], primaryFeatureLayers, joinedDynamicLayers, joinedFeatureLayers, joinedGeometries, processingType, srMatch, true)];
                    case 3:
                        featureResults = _a.sent();
                        _a.label = 4;
                    case 4:
                        results = tslib_1.__spread(dynamicResults, featureResults);
                        //const results: { id: string; guid?: string; objectIds?: number[]; resultCount: number }[] = await this.spatialQuery(isIntersect, primaryDynamicLayers, primaryFeatureLayers, joinedDynamicLayers, joinedFeatureLayers, joinedGeometries, processingType, srMatch);
                        return [4 /*yield*/, this.handleResults(results, spatialQueryParams, newLayer, isIntersect, null, null, id)];
                    case 5:
                        //const results: { id: string; guid?: string; objectIds?: number[]; resultCount: number }[] = await this.spatialQuery(isIntersect, primaryDynamicLayers, primaryFeatureLayers, joinedDynamicLayers, joinedFeatureLayers, joinedGeometries, processingType, srMatch);
                        _a.sent();
                        return [2 /*return*/, results];
                }
            });
        });
    };
    /**
     * Add current layers on the map in the format that spatial API accepts
     */
    SpatialQueryService.prototype.GetMapLayerList = function (layers, isPrimaryLayer) {
        if (isPrimaryLayer === void 0) { isPrimaryLayer = false; }
        var e_1, _a, e_2, _b;
        var maplayerList = [];
        try {
            for (var layers_1 = tslib_1.__values(layers), layers_1_1 = layers_1.next(); !layers_1_1.done; layers_1_1 = layers_1.next()) {
                var layer = layers_1_1.value;
                if (layer.mapcoreProps.hideInLegend) {
                    continue;
                }
                else if (this.layerService.getLayerType(layer) === 'group') {
                    try {
                        for (var _c = tslib_1.__values(layer.layers), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var sub = _d.value;
                            var maplayer = {
                                id: sub.id,
                                name: sub.mapcoreProps.name,
                                title: sub.title,
                                type: sub.type,
                                mapcoreProps: sub.mapcoreProps,
                                sublayers: [],
                                parsedUrl: ''
                            };
                            if (this.layerService.getLayerType(layer) === 'dynamic') {
                                maplayer.sublayers = sub.sublayers.toArray();
                            }
                            else if (this.layerService.getLayerType(layer) === 'feature') {
                                maplayer.parsedUrl = sub.parsedUrl;
                            }
                            maplayerList.push(maplayer);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
                else {
                    var maplayer = {
                        id: layer.id,
                        name: layer.mapcoreProps.name,
                        title: layer.title,
                        type: layer.type,
                        mapcoreProps: layer.mapcoreProps,
                        sublayers: [],
                        parsedUrl: '',
                        graphics: []
                    };
                    if (this.layerService.getLayerType(layer) === 'dynamic') {
                        maplayer.sublayers = layer.sublayers.toArray();
                    }
                    else if (this.layerService.getLayerType(layer) === 'feature') {
                        maplayer.parsedUrl = layer.parsedUrl;
                    }
                    else if (!isPrimaryLayer && this.layerService.getLayerType(layer) === 'graphics') {
                        maplayer.graphics = layer.graphics;
                    }
                    maplayerList.push(maplayer);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (layers_1_1 && !layers_1_1.done && (_a = layers_1.return)) _a.call(layers_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return maplayerList;
    };
    /**
     * Prepare layers for spatialQueryParams
     */
    SpatialQueryService.prototype.filterSelectedLayers = function (layers, dynamicLayers, featureLayers, graphicsLayers) {
        var _this = this;
        if (dynamicLayers === void 0) { dynamicLayers = null; }
        if (featureLayers === void 0) { featureLayers = null; }
        if (graphicsLayers === void 0) { graphicsLayers = null; }
        layers.forEach(function (layer) {
            switch (_this.layerService.getLayerType(layer)) {
                case 'dynamic': {
                    if (dynamicLayers) {
                        var dynamicLayerSpatial_1 = _this.getIDynamicLayerSpatialFromLayer(layer);
                        if (dynamicLayers.filter(function (x) { return x.id === dynamicLayerSpatial_1.id; }).length === 0) {
                            dynamicLayers.push(dynamicLayerSpatial_1);
                        }
                    }
                    break;
                }
                case 'feature': {
                    if (featureLayers) {
                        if (featureLayers.filter(function (x) { return x.id === layer.id; }).length === 0) {
                            featureLayers.push({
                                id: layer.id,
                                url: layer.parsedUrl.path,
                                query: layer.mapcoreProps && layer.mapcoreProps.query ? layer.mapcoreProps.query : null
                            });
                        }
                    }
                    break;
                }
                case 'graphics': {
                    if (graphicsLayers) {
                        layer.graphics.forEach(function (graphic) {
                            if (graphic.geometry.type === 'polygon') {
                                graphic.geometry = _this.formatPolygonGeometry(graphic.geometry);
                            }
                            graphicsLayers.push(JSON.stringify(graphic.geometry));
                        });
                    }
                    break;
                }
                default: break;
            }
        });
    };
    /**
     * Add GUID to the layer filter
     * @param layer MapCore layer object to filter by the spatial results GUID
     * @param guid MapCore spatial query GUID value
     * @param existingGuid Previous GUID present in the query that should be replaced with the new GUID
     */
    SpatialQueryService.prototype.updateLayerWithGUID = function (layer, guid, existingGuid) {
        if (existingGuid === void 0) { existingGuid = ''; }
        return this.updateQueryWithGUID(layer.mapcoreProps.query, guid, existingGuid);
    };
    /**
     * Add GUID to query
     * @param query MapCore query object
     * @param guid MapCore spatial query GUID value
     * @param existingGuid Previous GUID present in the query that should be replaced with the new GUID
     */
    SpatialQueryService.prototype.updateQueryWithGUID = function (query, guid, existingGuid) {
        if (existingGuid === void 0) { existingGuid = ''; }
        query = query || {};
        if (existingGuid === '') {
            var guidQuery = this.getGuidQuery(guid, null);
            return this.toSqlStringService.addFilter(query, guidQuery);
        }
        else {
            return this.toSqlStringService.replaceGUID(query, existingGuid, guid);
        }
    };
    /**
     * Add objectids to query
     * @param query MapCore query object
     * @param objectIds MapCore spatial objectId results
     * @param existingObjectIds Previous object Ids present in the query that should be replaced with new objectids
     */
    SpatialQueryService.prototype.updateQueryWithObjectIds = function (query, objectIds, existingobjectIds) {
        if (existingobjectIds === void 0) { existingobjectIds = []; }
        query = query || {};
        if (existingobjectIds && existingobjectIds.length > 0) {
            return this.toSqlStringService.replaceObjQuery(query, existingobjectIds.toString(), objectIds);
        }
        else {
            var tempQuery = this.getQueryByObjectIds(objectIds, null);
            return this.toSqlStringService.addFilter(query, tempQuery);
        }
    };
    SpatialQueryService.prototype.applyGeographicFilter = function (esriLayer, geometryString) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layerSpatial, results, spatialQueryParams;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        layerSpatial = this.getIDynamicLayerSpatialFromLayer(esriLayer);
                        return [4 /*yield*/, this.spatialQuery(true, [layerSpatial], null, null, null, [geometryString])];
                    case 1:
                        results = _a.sent();
                        spatialQueryParams = {
                            primaryDynamicLayers: [],
                            primaryFeatureLayers: [],
                            joinedDynamicLayers: [],
                            joinedFeatureLayers: [],
                            geometryString: geometryString,
                            isIntersect: true,
                            guid: ''
                        };
                        return [4 /*yield*/, this.handleResults(results, spatialQueryParams, false, true)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    //this is a temporary fix for polygon geometries. Ruidong will be updating the polygon draw tool to do this instead
    SpatialQueryService.prototype.formatPolygonGeometry = function (geometry) {
        geometry.rings.forEach(function (ring) {
            //add first point to last of the array to close the polygon
            ring.push(ring[0]);
        });
        return geometry;
    };
    /**
     * Converts an Oracle polygon Geometry string to an ESRI based polygon string
     */
    SpatialQueryService.prototype.getGeometryStringFromOraclePolygonString = function (oracleGeometryStrings) {
        var e_3, _a;
        var polygonPointStrings = [];
        try {
            for (var oracleGeometryStrings_1 = tslib_1.__values(oracleGeometryStrings), oracleGeometryStrings_1_1 = oracleGeometryStrings_1.next(); !oracleGeometryStrings_1_1.done; oracleGeometryStrings_1_1 = oracleGeometryStrings_1.next()) {
                var item = oracleGeometryStrings_1_1.value;
                var itemArray = item.split(')), ((');
                itemArray = itemArray.map(function (x) { return x.replace('MULTIPOLYGON ((', '').replace('POLYGON ((', '').replace('))', '').replace('(', '').replace(')', ''); });
                polygonPointStrings = polygonPointStrings.concat(itemArray);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (oracleGeometryStrings_1_1 && !oracleGeometryStrings_1_1.done && (_a = oracleGeometryStrings_1.return)) _a.call(oracleGeometryStrings_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        var ringsArray = polygonPointStrings.map(function (x) { return x.split(', ').map(function (y) { return y.split(' '); }); });
        var esriPolygon = { rings: ringsArray };
        return JSON.stringify(esriPolygon);
    };
    SpatialQueryService.prototype.spatialQuery = function (isIntersect, primaryDynamicLayers, primaryFeatureLayers, joinedDynamicLayers, joinedFeatureLayers, joinedGeometries, processingType, srMatch, returnOID) {
        if (srMatch === void 0) { srMatch = true; }
        if (returnOID === void 0) { returnOID = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!returnOID) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.spatialApi.spatialQuery_OID(isIntersect, primaryDynamicLayers, primaryFeatureLayers, joinedDynamicLayers, joinedFeatureLayers, joinedGeometries, processingType, srMatch)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.spatialApi.spatialQuery(isIntersect, primaryDynamicLayers, primaryFeatureLayers, joinedDynamicLayers, joinedFeatureLayers, joinedGeometries, processingType, srMatch)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     *  Run a spatial query for each layer returning results/GUIDs once all queries are completed.
     *  Similar to spatialQuery() but accepts layers and joinedLayers arrays with supported layer types respectively.
     *  @param layers Source layers/features for the query
     *  @param joinedLayers Layers to filter source features by
     */
    SpatialQueryService.prototype.spatialQueryLayers = function (isIntersect, layers, joinedLayers, processingType, srMatch) {
        if (processingType === void 0) { processingType = 'default'; }
        if (srMatch === void 0) { srMatch = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var primaryDynamicLayers, primaryFeatureLayers, joinedDynamicLayers, joinedFeatureLayers, joinedGeometries;
            return tslib_1.__generator(this, function (_a) {
                primaryDynamicLayers = [];
                primaryFeatureLayers = [];
                this.filterSelectedLayers(layers, primaryDynamicLayers, primaryFeatureLayers);
                joinedDynamicLayers = [];
                joinedFeatureLayers = [];
                joinedGeometries = [];
                this.filterSelectedLayers(joinedLayers, joinedDynamicLayers, joinedFeatureLayers, joinedGeometries);
                return [2 /*return*/, this.spatialQuery(isIntersect, primaryDynamicLayers, primaryFeatureLayers, joinedDynamicLayers, joinedFeatureLayers, joinedGeometries, processingType, srMatch)];
            });
        });
    };
    /**
     *  Run separate spatial queries for each layer returning results/GUIDs as they finish in an Observable.
     *
     *  * Use spatialQuery() or spatialQueryLayers() instead if processing can wait until
     *    all results are returned.
     *
     *  * Use spatialQueryInParallel() if the user needs updated when individual queries are completed.
     *
     *  Example:
     *
     *            await this.spatialQueryInParallel(layers, aoiLayers).forEach(result => console.log(result));
     *
     *  @param layers Source layers/features for the query
     *  @param joinedLayers Layers to filter source features by
     */
    SpatialQueryService.prototype.spatialQueryInParallel = function (isIntersect, layers, joinedLayers, processingType, srMatch) {
        var _this = this;
        var queries = layers.map(function (layer) { return _this.spatialQueryLayers(isIntersect, [layer], joinedLayers, processingType, srMatch); });
        return from(queries).pipe(mergeAll());
    };
    SpatialQueryService.prototype.getGeometry = function (selectedFeatures, selectedBoundaryType) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var geometries, boundaryFeatures, results, geometryString;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(selectedFeatures && selectedFeatures.length && selectedFeatures.length > 0)) return [3 /*break*/, 7];
                        if (!!selectedFeatures[0].geometry) return [3 /*break*/, 5];
                        if (!(selectedBoundaryType.apiQueryName === 'assistantAreasWinter' || selectedBoundaryType.apiQueryName === 'assistantAreasSummer')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.layerApi.getData(this.getLayerIdByName(selectedBoundaryType.apiQueryName), ['geometry'], { field: 'objectid', operator: 'IN', value: selectedFeatures.map(function (x) { return x.objectId; }).toString() })];
                    case 1:
                        results = (_a.sent());
                        geometries = results.flat();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.gisToolsService.getFeaturesByObjectId(selectedBoundaryType.apiQueryName, 'geometry', selectedFeatures.map(function (x) { return x.objectId; }))];
                    case 3:
                        boundaryFeatures = _a.sent();
                        geometries = boundaryFeatures.map(function (x) { return x.geometry; });
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        geometries = selectedFeatures.map(function (x) { return x.geometry; });
                        _a.label = 6;
                    case 6:
                        geometryString = this.getGeometryStringFromOraclePolygonString(geometries);
                        return [2 /*return*/, geometryString];
                    case 7: return [2 /*return*/, Promise.resolve(null)];
                }
            });
        });
    };
    SpatialQueryService.prototype.getLayerIdByName = function (name) {
        return environment.layers.filter(function (x) { return x.name === name; })[0].id;
    };
    SpatialQueryService.ngInjectableDef = i0.defineInjectable({ factory: function SpatialQueryService_Factory() { return new SpatialQueryService(i0.inject(i1.SpatialApi), i0.inject(i2.LayerApi), i0.inject(i3.LayerService), i0.inject(i4.GisToolsService), i0.inject(i5.ToSqlStringService)); }, token: SpatialQueryService, providedIn: "root" });
    return SpatialQueryService;
}());
export { SpatialQueryService };
